import { useLanguage } from '../utils/LanguageContext';
import translations from './ComponentsTranslations.lang.json';
import { ValidatedForm, FormChoice, FormSubmit } from './common/ValidatedForm';
import { updateInvestmentAccountTypeSchema } from '../shared/validations/investmentAccountValidations';
import { InvestmentAccountType } from '../shared/constants/investmentAccountConstants';
import { useAuth } from '../utils/AuthContext.js';

const AccountTypeSelection = ({ investmentAccount, onFinish }) => {
  const { lang, optionsForEnum } = useLanguage(translations);
  const { api } = useAuth();

  if (!investmentAccount) {
    return;
  }

  const { investmentAccountId, accountType } = investmentAccount;

  return (
    <ValidatedForm
      key="accountType"
      schema={updateInvestmentAccountTypeSchema}
      initialValues={{ accountType }}
      handleSubmit={async (values) => await api.updateInvestmentAccountType(investmentAccountId, values)}
      onFinish={onFinish}
    >
      <FormChoice name="accountType" options={optionsForEnum(InvestmentAccountType)} type="button" />
      <FormSubmit>{lang('next')}</FormSubmit>
    </ValidatedForm>
  );
};

export default AccountTypeSelection;
